import { Component, inject, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import packageJSON from '../../../../package.json';
import { PayeeButtonComponent } from '../../shared/payee-buttons/payee-button/payee-button.component';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  imports: [
    RouterLink,
    PayeeButtonComponent,
    RouterLinkActive,
  ],
  host: {
    '[class.closed]': 'closed()',
  },
})
export class SidebarComponent {
  private authService = inject(AuthService);

  readonly closed = signal(false);

  get version() {
    return packageJSON.version;
  }

  async logout() {
    await this.authService.logout();
  }
}
